type TransitionProposalHoldingsColumnKeys =
  | "name"
  | "ticker"
  | "quantity"
  | "costBasis"
  | "price"
  | "marketValue"
  | "unrealizedGainOrLoss"
  | "percentOfAccount"
  | "type"
  | "fileName"
  | "accountName"
  | "statementPeriod"
  | "actions";

export interface HoldingsTableColumn {
  value: TransitionProposalHoldingsColumnKeys;
  label: string;
  inputType: string | undefined;
  adornment: string | undefined;
  width: number | string;
  maxWidth?: number | string;
}

export const columns: HoldingsTableColumn[] = [
  {
    value: "name",
    label: "Name",
    inputType: "text",
    adornment: undefined,
    width: 250,
  },
  {
    value: "ticker",
    label: "Ticker",
    inputType: "text",
    adornment: undefined,
    width: 75,
  },
  {
    value: "quantity",
    label: "Quantity",
    inputType: "number",
    adornment: undefined,
    width: 75,
  },
  {
    value: "costBasis",
    label: "Cost Basis",
    inputType: "number",
    adornment: "$",
    width: 75,
  },
  {
    value: "price",
    label: "Price",
    inputType: "number",
    adornment: "$",
    width: 100,
  },
  {
    value: "marketValue",
    label: "Market Value",
    inputType: "number",
    adornment: "$",
    width: 75,
  },
  {
    value: "unrealizedGainOrLoss",
    label: "Unrealized Gain/Loss",
    inputType: "number",
    adornment: "$",
    width: 85,
  },
  {
    value: "percentOfAccount",
    label: "Percent",
    inputType: "number",
    adornment: "%",
    width: 35,
  },
  {
    value: "type",
    label: "Type",
    inputType: "text",
    adornment: undefined,
    width: 85,
  },
  {
    value: "fileName",
    label: "File Name",
    inputType: "text",
    adornment: undefined,
    width: 100,
  },
  {
    value: "accountName",
    label: "Account Name",
    inputType: "text",
    adornment: undefined,
    width: 200,
  },
  {
    value: "statementPeriod",
    label: "Statement Period",
    inputType: "text",
    adornment: undefined,
    width: 100,
  },
  {
    value: "actions",
    label: "Actions",
    inputType: undefined,
    adornment: undefined,
    width: "2.5%",
  },
];

export const summaryDataMap = {
  marketValue: "Market Value Summary",
  unrealizedGainOrLoss: "Unrealized Gain/Loss",
  summary: "Summary",
};
